// Futuristic theme design tokens based on the UI redesign plan
// This file defines the color palette, typography, spacing, and other design elements

// Dark theme colors - futuristic cyberpunk-inspired palette
export const darkTheme = {
  // Primary colors
  primary: '#4D61FC', // Vibrant blue
  primaryHover: '#5A71FF',
  primaryActive: '#3A4DE0',

  // Secondary colors
  secondary: '#18EDC0', // Neon teal
  secondaryHover: '#23FDCF',
  secondaryActive: '#12DAB0',

  // Accent colors
  accent: '#EB00FF', // Electric purple
  accentHover: '#FF33FF',
  accentActive: '#D100E6',

  // Background colors
  background: '#0C0E16', // Deep space blue
  surfacePrimary: '#161927', // Dark slate
  surfaceSecondary: '#1E2234', // Midnight blue

  // Text colors
  textPrimary: '#FFFFFF',
  textSecondary: '#BFC9E3',
  textTertiary: '#8590A6',

  // Feedback colors
  success: '#00DC82', // Vibrant green
  warning: '#FF9F00', // Amber
  error: '#FF3D71', // Vivid red
  info: '#05A2FB', // Information blue

  // UI element colors
  border: 'rgba(255, 255, 255, 0.12)',
  divider: 'rgba(255, 255, 255, 0.08)',
  hover: 'rgba(255, 255, 255, 0.05)',
  focus: 'rgba(77, 97, 252, 0.4)',

  // Elevation colors
  elevation1: 'rgba(0, 0, 0, 0.1)',
  elevation2: 'rgba(0, 0, 0, 0.2)',
  elevation3: 'rgba(0, 0, 0, 0.3)',

  // Gradient colors
  gradient1: 'linear-gradient(135deg, #4D61FC 0%, #05A2FB 100%)',
  gradient2: 'linear-gradient(135deg, #18EDC0 0%, #05A2FB 100%)',
  gradient3: 'linear-gradient(135deg, #EB00FF 0%, #4D61FC 100%)',
};

// Light theme colors - clean but still futuristic
export const lightTheme = {
  // Primary colors
  primary: '#3D52E4', // Vibrant blue (adjusted for light mode)
  primaryHover: '#4D61FC',
  primaryActive: '#3245D0',

  // Secondary colors
  secondary: '#0EDBAF', // Teal (adjusted for light mode)
  secondaryHover: '#18EDC0',
  secondaryActive: '#0BC9A0',

  // Accent colors
  accent: '#D100E6', // Purple (adjusted for light mode)
  accentHover: '#EB00FF',
  accentActive: '#B800CC',

  // Background colors
  background: '#F5F7FA', // Light gray
  surfacePrimary: '#FFFFFF', // White
  surfaceSecondary: '#E9EEF5', // Light blue-gray

  // Text colors
  textPrimary: '#0C0E16',
  textSecondary: '#4A5568',
  textTertiary: '#718096',

  // Feedback colors
  success: '#00C876', // Green
  warning: '#F59A23', // Amber
  error: '#F5325B', // Red
  info: '#0492E2', // Blue

  // UI element colors
  border: 'rgba(0, 0, 0, 0.12)',
  divider: 'rgba(0, 0, 0, 0.08)',
  hover: 'rgba(0, 0, 0, 0.05)',
  focus: 'rgba(61, 82, 228, 0.4)',

  // Elevation colors
  elevation1: 'rgba(0, 0, 0, 0.05)',
  elevation2: 'rgba(0, 0, 0, 0.08)',
  elevation3: 'rgba(0, 0, 0, 0.12)',

  // Gradient colors
  gradient1: 'linear-gradient(135deg, #3D52E4 0%, #0492E2 100%)',
  gradient2: 'linear-gradient(135deg, #0EDBAF 0%, #0492E2 100%)',
  gradient3: 'linear-gradient(135deg, #D100E6 0%, #3D52E4 100%)',
};
